import { render, staticRenderFns } from "./ProductListFiltered.vue?vue&type=template&id=0bffe82d&scoped=true"
import script from "./ProductListFiltered.vue?vue&type=script&lang=ts"
export * from "./ProductListFiltered.vue?vue&type=script&lang=ts"
import style0 from "./ProductListFiltered.vue?vue&type=style&index=0&id=0bffe82d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bffe82d",
  null
  
)

export default component.exports